module.exports = __webpack_public_path__ + "assets/images/premium-features/unassigned-slots-0ebe01.png";